module.exports = __webpack_public_path__ + "static/media/Lockton_Marine_P&I_Market_Review_2025_Edition.ce7dd909.pdf";